// Font loader utility to dynamically load Google Fonts
export const loadGoogleFont = (fontFamily) => {
  if (!fontFamily || fontFamily.trim() === '') {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    // Check if font is already loaded
    const existingLink = document.querySelector(`link[href*="${encodeURIComponent(fontFamily)}"]`);
    if (existingLink) {
      resolve();
      return;
    }

    // Create link element for Google Fonts
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(fontFamily)}:wght@300;400;500;600;700&display=swap`;
    
    link.onload = () => {
      console.log(`Font "${fontFamily}" loaded successfully`);
      resolve();
    };
    
    link.onerror = () => {
      console.warn(`Failed to load font "${fontFamily}"`);
      reject(new Error(`Failed to load font: ${fontFamily}`));
    };

    // Add to head
    document.head.appendChild(link);
  });
};

// Check if a font is available in the browser
export const isFontAvailable = (fontFamily) => {
  const testString = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const testSize = '72px';
  const fallbackFont = 'monospace';

  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  // Test with fallback font
  context.font = `${testSize} ${fallbackFont}`;
  const fallbackWidth = context.measureText(testString).width;

  // Test with target font, fallback to monospace
  context.font = `${testSize} "${fontFamily}", ${fallbackFont}`;
  const targetWidth = context.measureText(testString).width;

  // If widths are different, the font is available
  return targetWidth !== fallbackWidth;
};

// Map of font names to their Google Fonts equivalents
export const fontMap = {
  'maaja': 'Mali', // Assuming 'maaja' should map to Mali font
  'noto': 'Noto Sans Thai',
  'roboto': 'Roboto',
  'opensans': 'Open Sans',
  'lato': 'Lato',
  'montserrat': 'Montserrat',
  'playfair': 'Playfair Display',
  'dancing': 'Dancing Script',
  'great-vibes': 'Great Vibes',
  'sacramento': 'Sacramento',
};

// Get the actual Google Font name from a font key
export const getGoogleFontName = (fontKey) => {
  return fontMap[fontKey?.toLowerCase()] || fontKey;
};
